import { render, staticRenderFns } from "./buy-credit-modal.vue?vue&type=template&id=5bed2081&"
import script from "./buy-credit-modal.vue?vue&type=script&lang=js&"
export * from "./buy-credit-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports